import { CustomSocialLinksProfile } from '../CustomSocialLinks';

export const Other: CustomSocialLinksProfile = {
  name: 'other',
  matches: [
    {
      match: (input: string) => {
        try {
          const url = new URL(input);
          if(url.protocol === 'https:' || url.protocol === 'http:') {
            return input;
          }
        } catch {
          if('https://'.includes(input)){
            return input;
          }
          if (new URL('https://'+input)) {
            return 'https://'+ input;
          }
          return undefined;
        }
      },
      pattern: '{PROFILE_ID}',
      type: 0
    }
  ]
};
